import axios from "axios";
import service from "@/utils/axios-v2";

const services = axios.create({
  baseURL: process.env.VUE_APP_URL,
  timeout: 30000,
});

// 根据经纬度获取时区
export async function getSearchTimeZone(lat, lon, cancelToken) {
  const Res = await services({
    baseURL: process.env.VUE_APP_HERE_MAP_REVGEOCODE_API,
    url: '/v1/revgeocode',
    method: 'get',
    params: {
      apiKey: process.env.VUE_APP_HERE_MAP_KEY,
      lang: 'en-US',
      at: `${lat},${lon}`,
      show: 'tz'
    },
    cancelToken
  })
  return Res.data.items[0]
  // const Res = await axios.get(
  //   `https://reverse.geocoder.cit.api.here.com/6.2/reversegeocode.json?prox=${lat},${lon}&mode=retrieveAddresses&app_id=${process.env.VUE_APP_HERE_MAP_APP_ID}&app_code=${process.env.VUE_APP_HERE_MAP_APP_CODE}&gen=9&locationattributes=tz`
  // );
  // return Res.data.Response.View[0].Result[0].Location;
}
export function uploadImage(fileJson) {
  const form = new FormData();
  const headers = {
    "Content-Typ": "multipart/form-data",
  };
  form.append("image" || "pdf", fileJson.origin, fileJson.name);
  return services.post(
    `${process.env.VUE_APP_IMAGE_UPLOAD}/tp/support/image`,
    form,
    { headers: headers }
  );
}

// 根据经纬度获取时区
export function getRouteImage(
  data = "&waypoint0=29.7604267,-95.3698028&waypoint1=25.7616798,-80.1917902&poix0=29.7604267,-95.3698028&poix1=25.7616798,-80.1917902",
  w = "342",
  h = "192"
) {
  // &waypoint0=29.7604267,-95.3698028
  // &waypoint1=25.7616798,-80.1917902
  // &poix0=29.7604267,-95.3698028
  // &poix1=25.7616798,-80.1917902
  // let data = '&waypoint0=29.7604267,-95.3698028&waypoint1=25.7616798,-80.1917902&poix0=29.7604267,-95.3698028&poix1=25.7616798,-80.1917902'
  // let w = '324'
  // let h = '192'
  return axios.get(
    `https://image.maps.ls.hereapi.com/mia/1.6/routing?apiKey=${process.env.VUE_APP_HERE_MAP_KEY}&w=${w}&h=${h}&lc=4066D4&poilbl=1&poitxs=16&nocrop=true&nocp=true&t=5&ml=eng&poithm=2&poifc=4066D4${data}`,
    {
      responseType: "blob",
    }
  );
}
/**
 *
 * @config get config basic
 * @param  params: {
 *   configList: ['driver_terminal', 'load_query_enum' , 'document_param' , 'expense_paid_by' , 'expense_driver' , 'expense_vehicle']
 * }
 */
export function getConfigBasic(
  params = {},
  data = [
    "driver_terminal",
    "load_query_enum",
    // "document_param",
    // "expense_paid_by",
    // "expense_driver",
    // "expense_vehicle",
  ]
) {
  return service({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/config/basic`,
    method: "post",
    data: data,
    params: params,
    headers: {
      "portal-token": true,
    },
  });
}



export function getOwnerList(data) {
  console.log(data, 'post')
  return service({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: '/zuul/owner/list',
    method: 'post',
    data,
    headers: {
      'portal-token': true
    },
  })
}